import React from "react";
import { Card, CardContent } from "@ui/card";
import { Skeleton } from "@ui/skeleton";

const PlaylistItemCardSkeleton = () => {
  return (
    <Card
      className={`w-full cursor-pointer p-3 hover:shadow-md dark:border-[#4F5056] dark:bg-[#37383F]`}
    >
      <CardContent className="flex items-center justify-start gap-5 p-0">
        <Skeleton className="h-[70px] w-[75px] rounded-md" />
        <div className="flex w-full flex-col items-start justify-center gap-2">
          <Skeleton className="h-[20px] w-1/2 rounded-md" />
          <Skeleton className="h-[20px] w-1/3 rounded-md" />
          <Skeleton className="h-[5px] w-3/4 rounded-md" />
        </div>
      </CardContent>
    </Card>
  );
};

export default PlaylistItemCardSkeleton;
